import router from '@/router'
import cmd from '@/common/Command'

const SampleModule = {
  namespaced: true,
  state: {
    rows: [],
    summaryRows: [],
    detailRows: [],
    subTitle: "",
    detailTitle: "",
    detailContent: ""
  },
  mutations: {
    setRows (state, value) {
      state.rows = value 
    },
    setSummaryRows (state, value) {
      state.summaryRows = value 
    },
    setDetailRows (state, value) {
      state.detailRows = value 
    },
    setSubTitle (state, value) {
      state.subTitle = value 
    },
    setDetailTitle (state, value) {
      state.detailTitle = value 
    },
    setDetailContent (state, value) {
      state.detailContent = value 
    }

  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //
    search ({ commit, state, rootState }) {
      
      if (state.rows.length != 0) {
        return
      }

      function callback(rows){
        var list = []

        //空欄を埋める
        $.each(rows, function(idx, row){
          if (idx) {
            //図版タイトル
            if (row[2].trim() == "" && row[3].trim() == "") {
              row[3] = rows[idx - 1][3]
            }

            //タイトル・ページ
            if (row[2].trim() == "") {
              row[1] = rows[idx - 1][1]
              row[2] = rows[idx - 1][2]
            }
          }
        })
        
        //
        $.each(rows, function(idx, row){
          if (row != "") {
            list.push({"id": row[0], "page" : row[1], "title": row[2], "subtitle": row[3], "detail_title": row[4], "content": row[5]}) 
          }
        })
        commit('setRows', list)

        //
        var titleArray = list.reduce((p, x) => (p.indexOf(x.page + ":" + x.title + ":" + x.subtitle) !== -1) ? p : [...p, x.page + ":" + x.title + ":" + x.subtitle], [])
        var wk = []
        $.each(titleArray, function(idx, row){
          var array = row.split(":")
          wk.push({
            "id": idx,
            "page": array[0],
            "title": array[1],
            "subtitle": array[2],
          })
        })

        //
        commit('setSummaryRows', wk)
      }
      cmd.getData("sample", callback)
          
    },
    //次ページ
    showDetail ({ commit, state, rootState }, id) {

      var title = ""
      var subtitle = ""
      $.each(state.summaryRows, function(idx, row){
          if (row.id == id) {
            title = row.title
            subtitle = row.subtitle
            return false
          }
      })

      var wk = []
      $.each(state.rows, function(idx, row){
        if (row.title == title && row.subtitle == subtitle) {
          wk.push(row)
        }
      })

      if (subtitle != "") {

        commit('setSubTitle', subtitle)
        commit('setDetailRows', wk)
        router.push('sampleDetail')
        
      } else {

        //図版タイトルがないものは詳細タイトルを図版タイトルとして利用
        $.each(state.rows, function(idx, row){
          if (row.title == title) {
            commit('setSubTitle', title)
            commit('setDetailRows', [row])
            return false
          }
        })
        router.push('sampleDetail')
      }

    },
    //次ページ
    showDetail2 ({ commit, state, rootState }, detailTitle) {
      commit('setDetailTitle', detailTitle)

      $.each(state.rows, function(idx, row){
        if (row.detail_title == detailTitle) {
          commit('setDetailContent', row.content)
          return false
        }
      })
      router.push('sampleDetail2')
    }
  },
  getters: {    
    getRows (state, getters, rootState) {
      return state.summaryRows
    },
    detailRows (state, getters, rootState) {
      return state.detailRows
    },
    subTitle (state, getters, rootState) {
      return state.subTitle
    },
    detailTitle (state, getters, rootState) {
      return state.detailTitle
    },
    detailContent (state, getters, rootState) {
      return state.detailContent
    }
    
  }
}

export default SampleModule



// WEBPACK FOOTER //
// ./src/store/modules/SampleModule.js